module.exports = __webpack_public_path__ + "img/Poland.ddd0bd19.png";